import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import Image from '@atlaskit/image';

import { mergeLiveDocI18n } from '@confluence/live-pages-utils/entry-points/mergeLiveDocI18n.ts';

import { CreatePageButton } from '../CreatePageButton.tsx';
import RecentEmptyStateDark from '../images/recent/RecentEmptyStateDark.svg';
import RecentEmptyStateLight from '../images/recent/RecentEmptyStateLight.svg';

const emptyStateStyles = css({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	position: 'relative',
	height: '128px',
	padding: token('space.300'),
	overflow: 'hidden',
});

const headerStyles = css({
	font: token('font.heading.xsmall'),
	marginBottom: token('space.100'),
});

const contentStyles = css({
	maxWidth: '400px',
});

const imageStyles = css({
	position: 'absolute',
	right: token('space.300'),
	top: token('space.300'),
});

const i18nBase = defineMessages({
	header: {
		id: 'home.views.overview.recent-empty-state.header',
		defaultMessage: 'Get out there and explore',
		description: 'Descriptive header shown when there are not recent pages',
	},
	body: {
		id: 'home.views.overview.recent-empty-state.body',
		defaultMessage: 'Once you visit, edit, or create pages, you’ll find the most recent ones here.',
		description:
			'Descriptive body shown when there are not recent pages indicating how to make pages appear',
	},
});

const i18nLiveDocs = defineMessages({
	body: {
		id: 'home.views.overview.recent-empty-state.body.livedocs',
		defaultMessage:
			'Once you visit, edit, or create pages or live docs, you’ll find the most recent ones here.',
		description: 'Updated version of home.views.overview.recent-empty-state.body',
	},
});

const i18n = mergeLiveDocI18n(i18nBase, i18nLiveDocs);

export const RecentWorkEmptyState = (): React.JSX.Element => {
	return (
		<div css={emptyStateStyles}>
			<div css={contentStyles}>
				<div css={headerStyles}>
					<FormattedMessage {...i18n.header} />
				</div>
				<FormattedMessage {...i18n.body} />
			</div>
			<div>
				<CreatePageButton
					appearance="default"
					creationLinkSource="home-overview-recentList"
					showCreateLivePageButton
				/>
			</div>
			<Image src={RecentEmptyStateLight} srcDark={RecentEmptyStateDark} css={imageStyles} alt="" />
		</div>
	);
};
